import React from 'react'
import { render } from 'react-dom'

import { multiButtonHrefDataAttribute as hrefDataAttribute, shopButtonDataAttribute, widgetMountFlag } from './constants'
import WidgetV2 from './v2/WidgetV2'
import { V2ConfigurationContext, getParams } from './contexts/Configuration'
import { setAnalyticsAllowed } from './consent'

import './i18n'

// TODO: GA event, we can implement this later, no one needs right now

window.SideChef = window.SideChef || {}
window.SideChef.setAnalyticsAllowed = setAnalyticsAllowed

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', () => {
    inject()
  })
} else {
  // 'DOMContentLoaded' event has already fired
  inject()
}

function inject() {
  injectFont()
  injectShopButtons()
}

function injectFont() {
  try {
    // inject link tag in head
    const linkOfDefaultFont = document.createElement('link')
    linkOfDefaultFont.rel = 'stylesheet'
    linkOfDefaultFont.type = 'text/css'
    linkOfDefaultFont.href = 'https://fonts.googleapis.com/css?family=Poppins:700&display=swap'
    document.head.appendChild(linkOfDefaultFont)
  } catch (error) {
    console.error('Error injecting font', error)
  }
}

export function injectShopButtons() {
  const buttonSlots = document.querySelectorAll(`[${shopButtonDataAttribute}]:not([${widgetMountFlag}])`)

  buttonSlots.forEach(container => {
    const href = container.getAttribute(hrefDataAttribute)
    container.setAttribute(widgetMountFlag, 'true')
    renderWidgetV2(container, href)
  })
}

function renderWidgetV2(container, recipeUrl = null) {
  // Save original html content, will render in React component
  const originalHtmlContent = container.innerHTML
  const isOriginalHtmlContentEmpty = originalHtmlContent.trim().length === 0

  const reactRoot = document.createElement('div')
  // Set 'contents' to avoid affect original layout
  reactRoot.style.display = 'contents'

  container.innerHTML = ''
  container.appendChild(reactRoot)

  render(
    <V2ConfigurationContext.Provider value={getParams(container)}>
      <WidgetV2 container={container} href={recipeUrl}>
        {isOriginalHtmlContentEmpty ? undefined : (<div dangerouslySetInnerHTML={{ __html: originalHtmlContent }} />)}
      </WidgetV2>
    </V2ConfigurationContext.Provider>,
    reactRoot
  )
}
